import React, {useEffect, useRef, useState} from 'react';
import QuestionDisplay from "../../common/QuestionDisplay";
import AnswerSelect from "../../common/AnswerSelect";
import NextButton from "../../common/results/NextButton";
import { withStyles } from "@mui/styles";
import QuestionCommentSection from "../../common/QuestionCommentSection";

const styles = {
  answersBox2:{position:"relative", height: "15rem", width: "100%"},
  answersBoxEditing:{position:"relative", height: "20rem", width: "100%"},
  answer:{position:"absolute", width: "100%"},
  buttonBox:{position:"relative", width: "100%"},
  row:{display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "space-between"},
};

function TwoDimension2QuestionPage(props) {
  const { surveyAttempt, submitAnswer, questionIndex, setQuestionIndex, isViewingShared, classes } = props;

  const {answers, survey:{questions, options}} = surveyAttempt;
  const {id:questionId, statement} = questions[questionIndex];

  // eslint-disable-next-line no-unused-vars
  const [answerId, [likely = null, impact = null]=[], answerDate, comment="", commentDate=null] = (answers[questionIndex] || []);
  const [slide, setSlide] = useState(true);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(null);
  const doAdvance = useRef(false);

  const setLikely = (val, callback=()=>{}) => {
    submitAnswer(questionId, [val, impact], new Date(Date.now()), comment, commentDate, callback);
  }
  const setImpact = (val, callback=()=>{}) => {
    submitAnswer(questionId, [likely, val], new Date(Date.now()), comment, commentDate, callback);
  }

  useEffect(() => {
    doAdvance.current = false;
    setEditing(likely !== null && impact !== null);
    setSlide(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionIndex])

  useEffect(() => {
    if(editing){
      return;
    }
    if(!!likely && !!impact && doAdvance.current){
      nextQuestion();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [likely, impact, doAdvance.current]);

  const nextQuestion = () => {
    if(!!likely && !!impact && (doAdvance.current || editing)) {
      doAdvance.current = false;
      setSlide(false);
      setTimeout(() => setQuestionIndex(Math.min(questions.length, questionIndex + 1)), 350);
    }
  };

  const likelyOpts = options.choices[0];
  const impactOpts = options.choices[1];

  return (
    <>
      <QuestionDisplay
        statement={statement}
        slide={slide}
      />
      <div className={editing ? classes.answersBoxEditing : classes.answersBox2}>
        {editing ? null :
          <div id={"questionAnswers"} className={classes.answer}>
            <AnswerSelect
              slideIn={slide}
              slideDirection={slide ? "right" : "left"}
              colorClass={likelyOpts.color_class}
              question={likelyOpts.instructions}
              answerOpts={likelyOpts.answers}
              labelMin={likelyOpts.answers[0].label}
              labelMid={likelyOpts.answers[Math.floor(likelyOpts.answers.length/2)].label}
              labelMax={likelyOpts.answers[likelyOpts.answers.length-1].label}
              value={likely}
              setVal={val => {
                if(saving !== null) {
                  return
                }
                setSaving([0, val])
                doAdvance.current = true;
                setLikely(val, () => {
                  setSaving(null)
                })
              }}
              saving={!saving ? null : saving?.[0] === 0 ? [saving[1]] : [null]}
            />
            <AnswerSelect
              slideIn={slide}
              slideDirection={slide ? "right" : "left"}
              colorClass={impactOpts.color_class}
              question={impactOpts.instructions}
              answerRange={impactOpts.answers.length}
              answerOpts={impactOpts.answers}
              labelMin={impactOpts.answers[0].label}
              labelMid={impactOpts.answers[Math.floor(impactOpts.answers.length / 2)].label}
              labelMax={impactOpts.answers[impactOpts.answers.length - 1].label}
              value={impact}
              setVal={val => {
                if(saving !== null) {
                  return
                }
                setSaving([1, val])
                doAdvance.current = true;
                setImpact(val, () => {
                  setSaving(null)
                })
              }}
              saving={!saving ? null : saving?.[0] === 1 ? [saving[1]] : [null]}
            />
          </div>}
        {editing ?
          <div id={"questionAnswers"} className={editing ? classes.answersBoxEditing : classes.answersBox2}>
            <div className={classes.row}>
              <AnswerSelect
                slideIn={false}
                colorClass={likelyOpts.color_class}
                question={likelyOpts.instructions}
                answerOpts={likelyOpts.answers}
                labelMin={likelyOpts.answers[0].label}
                labelMid={likelyOpts.answers[Math.floor(likelyOpts.answers.length / 2)].label}
                labelMax={likelyOpts.answers[likelyOpts.answers.length - 1].label}
                value={likely}
                setVal={val => {
                  if(saving !== null) {
                    return
                  }
                  setSaving([0, val])
                  setLikely(val, () => {
                    setSaving(null)
                  })
                }}
                saving={!saving ? null : saving?.[0] === 0 ? [saving[1]] : [null]}
              />
            </div>
            <div className={classes.row}>
              <AnswerSelect
                slideIn={false}
                colorClass={impactOpts.color_class}
                question={impactOpts.instructions}
                answerOpts={impactOpts.answers}
                labelMin={impactOpts.answers[0].label}
                labelMid={impactOpts.answers[Math.floor(impactOpts.answers.length / 2)].label}
                labelMax={impactOpts.answers[impactOpts.answers.length - 1].label}
                value={impact}
                setVal={val => {
                  if(saving !== null) {
                    return
                  }
                  setSaving([1, val])
                  setImpact(val, () => {
                    setSaving(null)
                  })
                }}
                saving={!saving ? null : saving?.[0] === 1 ? [saving[1]] : [null]}
              />
            </div>
            <div className={classes.row}>
              <NextButton
                nextQuestion={nextQuestion}
                answerDate={answerDate}
                disabled={likely === null || impact === null}
              />
            </div>
          </div>
          : null
        }
      </div>
      <QuestionCommentSection
        surveyAttempt={surveyAttempt}
        submitAnswer={submitAnswer}
        questionIndex={questionIndex}
        setQuestionIndex={setQuestionIndex}
        isViewingShared={isViewingShared}
      />
    </>
  )
}

export default withStyles(styles)(TwoDimension2QuestionPage);